<template>
  <div style="width: 100%">
    <b-navbar toggleable="lg" class="header-nav background-white" fixed="top">
      <b-navbar-toggle
        style="border: 0; padding-left: 0px; height: 41px"
        target="nav-collapse"
      >
        <template #default="{ expanded }">
          <b-img v-if="expanded" src="img/close-menu.svg"></b-img>
          <b-img v-else src="img/menu.svg"></b-img>
        </template>
      </b-navbar-toggle>

      <b-navbar-toggle
        style="border: 0; padding-left: 20px; height: 41px; padding-right: 0"
        target="nav-collapse2"
        @click="gotoCart()"
      >
        <div href="#/cart" class v-if="cartlength() > 0">
          <b-img src="img/shoppingcart.svg"></b-img>

          <b-badge variant="danger" style="position: relative; top: -15px">{{
            cartlength()
          }}</b-badge>
        </div>
        <div href="#/cart" class v-else>
          <b-img src="img/shoppingcart.svg"></b-img>
        </div>
      </b-navbar-toggle>

      <b-navbar-brand
        id="brand-img"
        href="/#/"
        style="margin-left: -96px; position: absolute; left: 50%; top: 0"
      >
        <b-img :src="logo" alt="Truthbrush"> </b-img>
      </b-navbar-brand>

      <b-collapse id="nav-collapse" is-nav style="margin-left: 0">
        <b-navbar-nav class="first-nav-item">
          <b-nav-item href="/#/select" class="nav-bar-item first-item"
            >Shop
          </b-nav-item>
          <b-nav-item href="/#/product" class="nav-bar-item"
            >Product</b-nav-item
          >
          <b-nav-item href="/#/provider" class="nav-bar-item"
            >For Dentist</b-nav-item
          >
        </b-navbar-nav>

        <!-- Right aligned nav items -->
        <b-navbar-nav class="ml-auto">
          <b-nav-item href="/#/faq" class="nav-bar-item">FAQs </b-nav-item>
          <b-nav-item href="/#/contact" class="nav-bar-item"
            >Support</b-nav-item
          >
          <b-nav-item href="/#/about" class="nav-bar-item">About</b-nav-item>
          

          <b-nav-item href="#/cart" class="hide-times" v-if="cartlength() > 0">
            <b-img src="img/shoppingcart.svg"></b-img>

            <b-badge variant="danger" style="position: relative; top: -15px">{{
              cartlength()
            }}</b-badge>
          </b-nav-item>
          <b-nav-item href="#/cart" class="hide-times" v-else>
            <b-img src="img/shoppingcart.svg"></b-img>
          </b-nav-item>
        </b-navbar-nav>

      </b-collapse>
    </b-navbar>
  </div>
</template>

<script>
import store from "../store";
export default {
  name: "nav-header",
  created() {
    window.addEventListener("scroll", this.handleScroll);
  },
  destroyed() {
    window.removeEventListener("scroll", this.handleScroll);
  },
  data() {
    return {
      logo: "/img/logo-1.svg",
      showcontainer: false,
      timeout: null,
      backgroundcolornav: "background-color-transparent",
      toggle: 0,
    };
  },
  methods: {
    getLogo() {
      return this.logo;
    },
    updateLogo(index) {
      //console.log(index);
      if (index == 0) {
        this.logo = "/img/logo-1.svg";
      } else if (index == 1) {
        this.logo = "/img/logo-3.svg";
      } else if (index == 2) {
        this.logo = "/img/logo-4.svg";
      } else if (index == 3) {
        this.logo = "/img/logo-2.svg";
      }
    },
    updateLogoProductPage(index) {
      if (index == 0) {
        this.logo = "/img/logo-prod-0.svg";
      } else if (index == 1) {
        this.logo = "/img/logo-prod-1.svg";
      } else if (index == 2) {
        this.logo = "/img/logo-prod-3.svg";
      } else if (index == 3) {
        this.logo = "/img/logo-prod-2.svg";
      } else if (index == 4) {
        this.logo = "/img/logo-prod-4.svg";
      } else if (index == 5) {
        this.logo = "/img/logo-prod-5.svg";
      } else if (index == 6) {
        this.logo = "/img/logo-prod-6.svg";
      }
    },
    handleScroll() {
      // Any code to be executed when the window is scrolled
      this.changeBackgroundNavBar();
    },
    goto(index) {
      if (index == 0) {
        window.location.href = "/#/tracker";
      } else if (index == 1) {
        window.location.href = "/#/product";
      } else if (index == 2) {
        window.location.href = "/#/select";
      } else if (index == 3) {
        window.location.href = "/#/provider";
      }
    },
    containerhover() {
      this.showcontainer = true;
      clearTimeout(this.timeout);
    },
    containerleave() {
      let context = this;
      this.timeout = setTimeout(function () {
        context.showcontainer = false;
      }, 200);
    },
    mouseover() {
      this.showcontainer = true;
      clearTimeout(this.timeout);
    },
    mouseleave() {
      let context = this;
      this.timeout = setTimeout(function () {
        context.showcontainer = false;
      }, 200);
    },
    cartlength() {
      return store.state.cartlength;
    },
    changeBackgroundNavBar() {
      if (window.scrollY > 20) {
        this.backgroundcolornav = "background-white";
      } else {
        this.backgroundcolornav = "background-transparent";
      }
    },
    gotoCart() {
      window.location.href = "#/cart";
    },
  },
  mounted() {
    if (window.document.documentMode) {
      window.location.href = "/unsupported.html";
    }
  },
};
</script>

<style lang="scss">
.fixed-top {
  top: 0px !important;
}

.background-white {
  background-color: white;
}

.background-transparent {
  background-color: transparent;
}

#nav-collapse {
  margin-left: 15px;
}

.nav-bar-item a {
  font-size: 20px;
  padding-right: 30px !important;

  color: #232d40 !important;
}

.header-nav {
  width: 100%;
}

@media (max-width: 1199px) {
  .header-nav {
    padding: 0.5rem 15px !important;
  }
  .hide-when-small-1200 {
    display: none !important;
  }
}
@media (min-width: 1200px) {
  #modal .modal-open .header-nav,
  #modal .modal-open .header-banner {
    padding-left: calc(50% - 600px + 34.5px) !important;
    padding-right: calc(50% - 600px + 51.5px) !important;
  }

  .hide-when-big-1200 {
    display: none;
  }

  .header-nav,
  .header-banner {
    padding-left: calc(50% - 600px + 43px) !important;
    padding-right: calc(50% - 600px + 43px) !important;
  }
}

@media only screen and (max-width: 1439px) {
  #nav-collapse {
    margin-left: 0px;
  }
}

@media only screen and (min-width: 1440px) {
  #modal .modal-open .header-nav,
  #modal .modal-open .header-banner {
    padding-left: calc(50% - 720px + 34.5px) !important;
    padding-right: calc(50% - 720px + 51.5px) !important;
  }

  .header-nav,
  .header-banner {
    padding-left: calc(50% - 720px + 43px) !important;
    padding-right: calc(50% - 720px + 43px) !important;
  }
  .b-nav-dropdown ul {
    display: none !important;
  }
}

.nav-wrapper {
  background-color: rgb(232, 232, 234);
  height: 61px;
}

.bluebtn2 {
  color: #12b8ed !important;
  border-color: #12b8ed !important;
}

.bluebtn2:hover {
  background-image: none;
  background-color: #12b8ed !important;
  color: #ffffff !important;
}

.nav-item:not(.b-nav-dropdown) a:hover {
  color: #12b8ed !important;
}

.b-nav-dropdown:hover > a,
.b-nav-dropdown:hover > a > span {
  color: #12b8ed !important;
}
.navbar-nav li:hover > .dropdown-menu {
  display: block;
}

.b-nav-dropdown > ul > li > a:hover {
  color: #12b8ed !important;
}

.navbar-toggler.not-collapsed .nav-bars-icon {
  display: none;
}

.navbar-toggler.not-collapsed .nav-times-icon {
  display: auto;
}

.navbar-toggler.collapsed .nav-bars-icon {
  display: auto;
}

.navbar-toggler.collapsed .nav-times-icon {
  display: none;
}

.navbar-toggler.not-collapsed ~ .navbar-collapse.collapse .hide-times {
  display: none;
}

@media (max-width: 768px) {
  .header-nav {
    padding: 0.5rem 15px !important;
  }
  .hide-when-small-1200 {
    display: none !important;
  }
}

@media (min-width: 769px) {
  #modal .modal-open #brand-img {
    left: calc(50% - 8.5px) !important;
  }

  #modal .modal-dialog {
    position: absolute !important;
    margin-right: 0 !important;
    right: 0px;
  }
}

#nav-collapse.show {
  background-color: rgba(255, 255, 255, 1);
  margin-left: -15px !important;
  margin-right: -20px !important;
  padding-left: 15px;
}

.first-item a {
  padding-left: 0 !important;
}
</style>

